// IOSentra wordmark — matches the marketing site's brand lockup
// (iosentraWebsite/src/components/brand/Logo.tsx): Space Grotesk semibold,
// tight tracking, "IO" in the vertical teal→blue brand gradient, "Sentra"
// inheriting the surrounding text color. Latin in every locale (dir=ltr).
export function IOSentraWordmark({ className = '' }: { className?: string }) {
  return (
    <span
      dir="ltr"
      className={`font-semibold tracking-tight ${className}`}
      style={{ fontFamily: "'Space Grotesk', 'Inter', system-ui, sans-serif" }}
    >
      <span className="bg-gradient-to-b from-[#00D4C3] to-[#0866FF] bg-clip-text text-transparent">IO</span>
      <span>Sentra</span>
    </span>
  );
}
